import React, { useContext } from "react";

import { useLocation } from "wouter";

import { loginContext } from "./Login";
import { useQueryState } from "../../../components/src/use-query-state";

export const TokenPage = (): React.ReactElement => {
    const [redirectUri] = useQueryState("redirect_uri", "none");
    const [, navigate] = useLocation();
    const { login } = useContext(loginContext);

    if (redirectUri && redirectUri !== "none") {
        const url = redirectUri;
        const hostname = new URL(url).hostname;
        const queryArg = new URLSearchParams({ api_key: login.token });
        if (hostname === "localhost") {
            if (typeof window !== "undefined") {
                return (
                    <div>
                        <div> Do you want to authorize localhost to act as you </div>
                        <button
                            className="btn bg-yellow-500"
                            type="button"
                            onClick={() => {
                                window.open(`${redirectUri}?${queryArg.toString()}`);
                                navigate("/", { replace: true });
                            }}
                        >
                            <div>Yes</div>
                        </button>
                        <button
                            className="btn bg-green-600 mx-3"
                            type="button"
                            onClick={() => {
                                navigate("/", { replace: true });
                            }}
                        >
                            <div>No</div>
                        </button>
                    </div>
                );
            }
        }
    }
    return <div></div>;
};
